import { useEffect as a } from "react";
const r = ({ gtmId: e = null }) => (a(() => {
  if (e !== null) {
    const t = document.createElement("script");
    t.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${e}');`, document.head.appendChild(t);
    const n = document.createElement("noscript");
    n.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${e}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`, document.body.appendChild(n);
  }
}, [e]), null);
export {
  r as default
};
